import { PaymentType, useJobContext } from 'pages/Job/context';

export interface PaymentFormHook {
  paymentType: PaymentType | undefined;
  formRef: React.MutableRefObject<HTMLDivElement | null>;
}

export default function usePaymentForm(): PaymentFormHook {
  const { paymentType, formRef } = useJobContext();

  return {
    paymentType,
    formRef,
  };
}
